let _ = require('lodash');

module.exports = RegionsFilter;

function RegionsFilter(customOptions) {
    let options = $.extend({}, customOptions);    
    if(!options.listElement) {
        throw new Error('listElement option is required')
    }
    this.filterListItems = $(options.listElement).children();
    this.filterListItems.click((event) => this.onFilterItemClicked($(event.target)));

    $(document).on('regionsFilterChange', (event, params) => this.onRegionsFilterChange(params.regionName));

    if (options.userRegionCode) {
        let userRegion = this.filterListItems.filter(`[data-region-code='${options.userRegionCode}']`)
        if (userRegion.length) {
            this.onFilterItemClicked(userRegion);
        }
    }
}

RegionsFilter.prototype = {
    onFilterItemClicked(element) {
        let regionName = element.data('region-name');
        $(document).trigger('regionsFilterChange', { regionName: regionName });
    },

    onRegionsFilterChange(regionName) {
        this.filterListItems.removeClass('active');
        this.filterListItems.filter(`[data-region-name='${regionName}']`).addClass('active');

    },
}